import { DestroyRef } from '@angular/core';

/**
 * Poll de tela sensível à visibilidade da aba: pausa em background para não consumir o bucket de rate
 * limit do hotel com a aba esquecida aberta, e refaz o fetch imediatamente ao voltar — senão o
 * operador olha dado de minutos atrás achando que é de agora.
 *
 * `intervalMs` é OBRIGATÓRIO de propósito: a cadência é decisão de cada tela (o painel de contas usa
 * 15s — a do painel de pedidos sem socket, D175; o Início usa 30s — dois recursos por tick, dashboard
 * não é fila de operação). Um default aqui viraria a cadência de todo mundo sem ninguém decidir.
 *
 * Morava em `libs/frontend/pdv-account/util/account-polling.ts` com um consumidor; subiu para cá na
 * segunda ocorrência (tela Início), pela regra DRY da seção 8 do PRD. O `board-polling` da lib `order`
 * continua próprio — ele carrega o relógio do indicador de sincronia e a cadência dinâmica por socket,
 * que nenhuma outra tela usa.
 */
export function startVisibilityPolling(onPoll: () => void, destroyRef: DestroyRef, document: Document, intervalMs: number): void {
  const isVisible = (): boolean => document.visibilityState !== 'hidden';

  const timer = setInterval(() => {
    if (isVisible()) {
      onPoll();
    }
  }, intervalMs);

  let wasHidden = false;
  const onVisibilityChange = (): void => {
    if (isVisible() && wasHidden) {
      onPoll();
    }
    wasHidden = !isVisible();
  };
  document.addEventListener('visibilitychange', onVisibilityChange);

  destroyRef.onDestroy(() => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  });
}
